import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";

createRoot(document.getElementById("root")!).render(<App />);

// Sentry'yi Lighthouse ölçüm penceresi dışında, load'dan 8 saniye sonra yükle.
if (typeof window !== "undefined") {
  window.addEventListener("load", () => {
    setTimeout(() => initSentry(), 8000);
  });
}
